import { gsap } from "gsap/dist/gsap";    
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger);

export function fromDown(element, duration) {
    gsap.from(element, {
        scrollTrigger: {
            trigger: element,
            start: "top bottom",
            end: "bottom top",
            scrub: false,
            markers: false,
        },
        y: 100,
        opacity: 0,
        duration: duration
    });
}
export function staggerfromDown(trigger, element, duration) {
    gsap.to(element, {
        scrollTrigger: {
            trigger: trigger,
            start: "top bottom-=200px",
            once: true,
            // scrub: false,
            // markers: false,
        },
        y: 0,
        opacity: 1,
        duration: duration,
        stagger: 0.2,
    });
}